var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationStopsale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2317_5877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9411 1.04541L15.4548 4.55903C15.7079 4.8122 15.8502 5.15558 15.8502 5.51362V10.4826C15.8502 10.8407 15.7079 11.1841 15.4548 11.4372L11.9411 14.9509C11.688 15.204 11.3446 15.3463 10.9865 15.3463H6.01753C5.65949 15.3463 5.31611 15.204 5.06294 14.9509L1.54931 11.4372C1.29614 11.1841 1.15391 10.8407 1.15391 10.4826L1.15391 5.51362C1.15391 5.15558 1.29614 4.8122 1.54931 4.55903L5.06294 1.04541C5.31611 0.792232 5.65949 0.65 6.01753 0.65L10.9865 0.65C11.3446 0.65 11.688 0.792232 11.9411 1.04541Z",
    fill: "white",
    stroke: "#FF746B",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 5.25C7 5.94036 6.44036 6.5 5.75 6.5C5.05964 6.5 4.5 5.94036 4.5 5.25C4.5 4.55964 5.05964 4 5.75 4C6.44036 4 7 4.55964 7 5.25Z",
    fill: "#FF746B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.75C12.5 11.4404 11.9404 12 11.25 12C10.5596 12 10 11.4404 10 10.75C10 10.0596 10.5596 9.5 11.25 9.5C11.9404 9.5 12.5 10.0596 12.5 10.75Z",
    fill: "#FF746B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11L11.5 5",
    stroke: "#FF746B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2317_5877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationStopsale);
export default __webpack_public_path__ + "static/media/notificationStopsale.247e561d43f8552cbec022d49e2e8bad.svg";
export { ForwardRef as ReactComponent };